import React, { useState } from 'react'
import Loader from './shared/Loader'
import { showFlashMessage } from '../helpers/utils'

export default function Join({ formPath, passwordAutocomplete, buttonText, refParams, termsUrl, privacyUrl, addendumUrl }) {
  const [password, setPassword]                       = useState('')
  const [loading, setLoading]                         = useState(false)
  const [passwordShown, setPasswordShown]             = useState(false)

  const disableSubmit = !(password.length)

  function handleSubmit(event) {
    event.preventDefault()
    if (disableSubmit) {
      showFlashMessage(Cas.translations.password_validation_alert, 'error')
    } else {
      save()
    }
  }

  function save(event) {
    setLoading(true)

    let formData = new FormData()
    formData.append('password', password)

    for(const refParamKey in refParams) {
      formData.append(refParamKey, refParams[refParamKey])
    }

    Rails.ajax({
      type: 'POST',
      url: formPath,
      dataType: 'json',
      data: formData,
      success: res => {
        if (res.redirectUrl) {
          window.location.href = res.redirectUrl
        } else {
          setLoading(false)
        }
      },
      error: res => {
        showFlashMessage(res.error, 'error')
        setLoading(false)
      }
    })
  }

  return (
    <>
      <div className='field' style={{ position: 'relative' }}>
        <label>
          { Cas.translations.password }
        </label>
        <input
          type={ passwordShown ? "text" : "password" }
          autoFocus
          autoComplete={ passwordAutocomplete }
          value={ password }
          onChange={ event => setPassword(event.target.value) }
        />
        { password.length > 0 &&
          <div className='show_password'>
            <i className={`pointer fa-light ${passwordShown ? 'fa-eye-slash' : 'fa-eye' }`} onClick={ ()=> setPasswordShown(prevState => !prevState) } />
          </div>
        }
      </div>

      <div className='actions'>
        { !loading ?
          <div className='flex-box items-center content-center'>
            <button type='submit' className={`button ${disableSubmit ? 'disabled' : ''}`} onClick={ handleSubmit }>
              { buttonText  }
            </button>
          </div>
          :
          <div className='flex-box content-center'>
            <Loader size='small' position='centered'/>
          </div>
        }
      </div>
    </>
  )
}
